module.exports = __webpack_public_path__ + "img/email.9bc32bb4.svg";